
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as tasksDSCLO0esxorEuQ5mjAnvztgyapMhzZqDpJ7_f96SzRwMeta } from "/app/pages/tasks.vue?macro=true";
import { default as agendaT7U4173aTQucYTJTl4kxrJy405vDfj04oxkFV1eB84UMeta } from "/app/pages/agenda.vue?macro=true";
import { default as indexM146nxsd_45YahYZ9IWPnjG_45RwvcJtgMdVqtl9B76LWxYMeta } from "/app/pages/commerce/sites/index.vue?macro=true";
import { default as index1TBkkIFyRCDe_biNzta4ySdhfv8_oStMoCivI4j1qM0Meta } from "/app/pages/commerce/contacts/index.vue?macro=true";
import { default as index2G7XombD1Mej3y6dmk6XJZgSI4ndy8n4HxLHS_45mkp0oMeta } from "/app/pages/commerce/sites/[siteId]/index.vue?macro=true";
import { default as contacts_45j5uYpvT6w2Jxa_45qYM_45Q7ECE5WaIslEmlKevoZNBJ2wMeta } from "/app/pages/commerce/sites/[siteId]/contacts.vue?macro=true";
import { default as relations1WG4xRvxk85rX4MX2JkyhHva1UvW5ZW4Y3cB_45htnEg8Meta } from "/app/pages/commerce/sites/[siteId]/relations.vue?macro=true";
import { default as _91siteId_93QwBV2NWjKbvASP4alXs8ZO7206UCBIiqvy5we0wdzFQMeta } from "/app/pages/commerce/sites/[siteId].vue?macro=true";
import { default as editSPv_45LpubLhB3cxYQq0kTMzBUrODLA1yFkvlfvHTUTUQMeta } from "/app/pages/commerce/contacts/[contactId]/edit.vue?macro=true";
import { default as indexaWmJIhhulMPUnLq_7d1lC2RQ3KuQHgqd_6EwnCQdEYkMeta } from "/app/pages/commerce/contacts/[contactId]/index.vue?macro=true";
import { default as siteswW1eyWgJ1ggOq_7Rtv1xYy_45GJ2U8GySYOmdP1626fTMMeta } from "/app/pages/commerce/contacts/[contactId]/sites.vue?macro=true";
import { default as relationsKM4Lx_77vlJaxA_lazS1Z_450Mc3dCHLY6a_3wSjNYGNsMeta } from "/app/pages/commerce/contacts/[contactId]/relations.vue?macro=true";
import { default as _91contactId_93HTFrNjsZYFngLiiOW4EyVvkmix_YtXASJiKoP2aee8sMeta } from "/app/pages/commerce/contacts/[contactId].vue?macro=true";
import { default as _91appointmentId_93rtP5qS6gxZu_45qxA1HkiYu9Jq9gO0GcYDabp7M10hY0IMeta } from "/app/pages/commerce/appointments/[appointmentId].vue?macro=true";
import { default as commerceUhhyWRxhLgV8s2SG4_jH11WXOEp78B5x1UH5i9cJQN8Meta } from "/app/pages/commerce.vue?macro=true";
import { default as reportingF6x4kViyKcsqk2PDelfpy9i9KLFBFtICBSQTxqvFdGsMeta } from "/app/pages/reporting.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as notificationsB9uD7vf6BNbcGL3D9HpazycZMRkcPWG6ea6_45mQfWSE0Meta } from "/app/pages/notifications.vue?macro=true";
import { default as indexIWQa0IgSu7cy6lNZs_45TfU5FO6XNoRIlxtHKQUd551xIMeta } from "/app/pages/admin/banks/index.vue?macro=true";
import { default as index1zRBk23WUa9s_45mpb2B7JqoqGMudXvr8t2Lo0hMsfgCwMeta } from "/app/pages/admin/brands/index.vue?macro=true";
import { default as _91_91id_93_937r1OYvCtCAqniWOmIIhweXT5ikiYq0bAgGWya47L6CUMeta } from "/app/pages/appointment/[[id]].vue?macro=true";
import { default as index55PkSyNw0jUt5u31_451eAirOD0PXx3Cte4qRZjv1aAxYMeta } from "/app/pages/opportunities/index.vue?macro=true";
import { default as cashflow32_45TMry32DNLaFEsGydw3Ed7s_45B3sxXM7FFNS_IPBmEMeta } from "/app/pages/simulation/cashflow.vue?macro=true";
import { default as _91bankId_93rpSdB_wfP_45yRcT50aKkVv8DdaMMQjOIxt1bRhI1JhhsMeta } from "/app/pages/admin/banks/[bankId].vue?macro=true";
import { default as cashflow4BUgro1qBhWed741eS_4522xsW5LiZXdPo_45V03moPz_4588Meta } from "/app/pages/opportunity/cashflow.vue?macro=true";
import { default as index9KNi0gKILxY7UuBKE_VW_7g89sJxGm_45pcpmXrKMP0OoMeta } from "/app/pages/admin/positions/index.vue?macro=true";
import { default as _91brandId_93Vw3T4eBgBHuwfejUYUYWvSxaEXi5h4Vt45T421LJM_YMeta } from "/app/pages/admin/brands/[brandId].vue?macro=true";
import { default as simulationE7_45tnGcQO4eZCCBCM8CtpqqKpvtzT0hUHhG63gYlyCAMeta } from "/app/pages/opportunity/simulation.vue?macro=true";
import { default as indexH1XdcgOGd92kFLTh5fO_MnInayrepnQlZqIuUN7u6yIMeta } from "/app/pages/admin/orientation/index.vue?macro=true";
import { default as index9vbn72WHBJu4_457ec58TyLqxfVJGerdIPt3wG8kNql2gMeta } from "/app/pages/admin/usury_rates/index.vue?macro=true";
import { default as indexCuv63lI2SvJSS03MIlhdOpwG_45wPeEX7ucMe_45fYJdUNEMeta } from "/app/pages/admin/charge_types/index.vue?macro=true";
import { default as indexfBhdd6Ih_45g6OqocUbkgn0Uc4MxcW0s9aG2w6UFnMq7oMeta } from "/app/pages/admin/credit_types/index.vue?macro=true";
import { default as indexOLCYP2CpWeW0CfB0NuQbfqFQwF6wyT4QTXgx_kqFFm4Meta } from "/app/pages/admin/income_types/index.vue?macro=true";
import { default as indexDh0mdEeoqpEabm5mG4c8pSrSh3Ypc_w1CcYjHlZr6MkMeta } from "/app/pages/admin/bank_products/index.vue?macro=true";
import { default as indexQhXMK1JLPIcvPJlp8VzjrtiZbW_72ryTY_YHUCiML_QMeta } from "/app/pages/admin/insurance_types/index.vue?macro=true";
import { default as _91positionId_93d8j9PqO4SwDEpG2hF7_45rRDmDhX9NW_451KVhxcpH_45OKF4Meta } from "/app/pages/admin/positions/[positionId].vue?macro=true";
import { default as index_45Q1mECiYEejd8aBg5M7oZjTpb1_wL5PQwbQgBQBeMyIMeta } from "/app/pages/settings/notifications/index.vue?macro=true";
import { default as indexPs5ZnnvsBBoAZxty5XEJfLV6dT2hlq1LR7VnVQfoGB0Meta } from "/app/pages/admin/contact_positions/index.vue?macro=true";
import { default as indexSI0pqk81oEJWvLR9xGhLW8l5Fk8GhpxOYsQMJmgqIwIMeta } from "/app/pages/admin/transaction_types/index.vue?macro=true";
import { default as indexQ2QoJIj_45xUBXthiRqUkm9Q5Ao_45rOSIxYOJ_Ejdz03gQMeta } from "/app/pages/admin/excluded_documents/index.vue?macro=true";
import { default as indexiIdKt3n302VqiBPlxhhybAz0_5fnQc06BY6eLs2syQkMeta } from "/app/pages/admin/contact_event_types/index.vue?macro=true";
import { default as _91usuryRateId_93tTrQlnKKRYf3Qjwi61DNxJsMjBF7D_Q6ZDdDpb37iZ0Meta } from "/app/pages/admin/usury_rates/[usuryRateId].vue?macro=true";
import { default as _91ChargeTypeId_93WIeiwKGDMB15XVHsfgTrQzIW_45rFWyW0zYG0PiJ_45lFbMMeta } from "/app/pages/admin/charge_types/[ChargeTypeId].vue?macro=true";
import { default as _91creditTypeId_93netNLhsi6y9D2D20Qk5xFbRvSOLs5es_9Iq9Zc30unoMeta } from "/app/pages/admin/credit_types/[creditTypeId].vue?macro=true";
import { default as _91incomeTypeId_93mfPIGIwk2qKmX1f0SjhoIGy_AUFz41faOcTLhnqOnowMeta } from "/app/pages/admin/income_types/[incomeTypeId].vue?macro=true";
import { default as editFfAyXCPULifBTEQJPy4QmcyUh9rWPcndCHfGBdA8H_QMeta } from "/app/pages/opportunities/[opportunityHashId]/edit.vue?macro=true";
import { default as historyXgtceBgDMUnyNQkefZjpcMM5yXNZYQPiRpG95ufFuAEMeta } from "/app/pages/opportunities/[opportunityHashId]/history.vue?macro=true";
import { default as previewS5WK_45SsVDTn_45lP3fcm5qBDkqazVOJk1MQWOIu6xYcZcMeta } from "/app/pages/opportunities/[opportunityHashId]/preview.vue?macro=true";
import { default as balanceSm2qYMR7Gpq4h6YGnw25f__2JByTiV0NT_pbsoVT8lUMeta } from "/app/pages/opportunities/[opportunityHashId]/analysis/balance.vue?macro=true";
import { default as commentsqv72mqDlih10PK_7BHfsi_10pm_2jpZcaWYIU09LbSQMeta } from "/app/pages/opportunities/[opportunityHashId]/analysis/comments.vue?macro=true";
import { default as recap_45iavKFYFREV76BjcxnYbv0TNJpYKSBsEVdZTYNgqkD5fNsMeta } from "/app/pages/opportunities/[opportunityHashId]/analysis/recap-ia.vue?macro=true";
import { default as synthesiszHRJv14zLVsAh58Ko9dl7LfU_45NTEm4GwwMqJ_45asm3x4Meta } from "/app/pages/opportunities/[opportunityHashId]/analysis/synthesis.vue?macro=true";
import { default as operationsj6Z0GxiWJsTmfcCathLhyaOT6IuXE3_BHlcBLPzShjcMeta } from "/app/pages/opportunities/[opportunityHashId]/analysis/operations.vue?macro=true";
import { default as _91bankAccountId_93Xbm01ENaXmbBOJ_45xx9jATweratbJhQMabQWnPsNb_7gMeta } from "/app/pages/opportunities/[opportunityHashId]/analysis/bank-accounts/[bankAccountId].vue?macro=true";
import { default as _91bankAccountStatementId_93r1ZymAWvUUYHwRmxIZ0fNLearDE1Q6Sv0Pv5qWK_45zz4Meta } from "/app/pages/opportunities/[opportunityHashId]/analysis/bank-account-statements/[bankAccountStatementId].vue?macro=true";
import { default as analysisAKQQtEDcUyqSeBUnfXeXuGqEehVH2YRaU259xD84ImYMeta } from "/app/pages/opportunities/[opportunityHashId]/analysis.vue?macro=true";
import { default as deletedA_45ZFJowZJ5OoF2890jvlyP0Zw1Olg1KsTZFtTOJK10AMeta } from "/app/pages/opportunities/[opportunityHashId]/messages/deleted.vue?macro=true";
import { default as receivedgCU476r6Hm92WWfiV0B8Oll_Y_45XXdmTgZWlHIvVcRLAMeta } from "/app/pages/opportunities/[opportunityHashId]/messages/received.vue?macro=true";
import { default as generatedK42VuRKD1m9I_XF2Cub9zC90mEnUZbiQnBPqBu2JwH8Meta } from "/app/pages/opportunities/[opportunityHashId]/messages/generated.vue?macro=true";
import { default as messagesZtZvDqqPdjKU0Qd5BnSxwJN2CaXdEJ_Kr1H86TcPTucMeta } from "/app/pages/opportunities/[opportunityHashId]/messages.vue?macro=true";
import { default as all11Sj6Vuoe6gBG0UbKUSMNIJOYYXdokJNGm9y4j6b1X8Meta } from "/app/pages/opportunities/[opportunityHashId]/documents/all.vue?macro=true";
import { default as deleted6fbDg2aD4B_45qNeMotlRluZFDofUhfv9JCW5bmQ8Y450Meta } from "/app/pages/opportunities/[opportunityHashId]/documents/deleted.vue?macro=true";
import { default as documentsmbSd_n24kYkkz9mSTMIbR8e73wNrriumBX2UiWXTZNYMeta } from "/app/pages/opportunities/[opportunityHashId]/documents.vue?macro=true";
import { default as autoQi3OGr0MMa6I5Yj_45HtuKKImVVaBDiyPX4K21TyL_4wsMeta } from "/app/pages/opportunities/[opportunityHashId]/simulation/auto.vue?macro=true";
import { default as _91simulationLegacyId_93xLjHEq8xxGe7KKxBqg9ieWL61tSy01By1Ryc7gYSR54Meta } from "/app/pages/opportunities/[opportunityHashId]/simulation/blink/[simulationLegacyId].vue?macro=true";
import { default as simulationvyf0y5dBsReMSC8YG98o117dJCvFpGa_51qdum3j1eIMeta } from "/app/pages/opportunities/[opportunityHashId]/simulation.vue?macro=true";
import { default as _91opportunityHashId_93pk15iCnpQFE_fkoHwlkEH7Ufh4tZuczWpy1M0nxbD1QMeta } from "/app/pages/opportunities/[opportunityHashId].vue?macro=true";
import { default as _91bankProductId_93bGHTKa9eRwrZRmjcNjdBdRcDuJdS12AcZEBcXjANvsMMeta } from "/app/pages/admin/bank_products/[bankProductId].vue?macro=true";
import { default as indexpS78U8OMWcRO8DTmx_45Vx2kzfvTv3M8NZ1DMqYFZZuPoMeta } from "/app/pages/admin/bank_product_commissions/index.vue?macro=true";
import { default as _91insuranceTypeId_93ekOt4KsjIzi9yZ_45RvjHGYbgytgzi2YUDv6_45gdbeEeiEMeta } from "/app/pages/admin/insurance_types/[insuranceTypeId].vue?macro=true";
import { default as _91contactPositionId_93xscVjtucgZgUixFi5twNGEHoU4ih_45iPL4Q2kTbfKfqIMeta } from "/app/pages/admin/contact_positions/[contactPositionId].vue?macro=true";
import { default as _91TransactionTypeId_93YNdMc5Gf9lwwUTPYTKsXFRjtcUWVLvtLH9_XOOQXS_UMeta } from "/app/pages/admin/transaction_types/[TransactionTypeId].vue?macro=true";
import { default as _91excludedDocumentId_93jJY4_mz0gpgYoOkfP9NxtDNLX_45s9S3k04USJnkjy6w8Meta } from "/app/pages/admin/excluded_documents/[excludedDocumentId].vue?macro=true";
import { default as _91ContactEventTypeId_93t28DlbsIHHgowEh24N8nhCkaTF9vuLfdyRhfE27c7uYMeta } from "/app/pages/admin/contact_event_types/[ContactEventTypeId].vue?macro=true";
import { default as _91bankProductCommissionId_93z_45Xoy2YOlxhsmWBU_45scGdAIHzfHmB1OvtgE_uRr8cNcMeta } from "/app/pages/admin/bank_product_commissions/[bankProductCommissionId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    component: () => import("/app/pages/tasks.vue")
  },
  {
    name: "agenda",
    path: "/agenda",
    component: () => import("/app/pages/agenda.vue")
  },
  {
    name: "commerce",
    path: "/commerce",
    component: () => import("/app/pages/commerce.vue"),
    children: [
  {
    name: "commerce-sites",
    path: "sites",
    component: () => import("/app/pages/commerce/sites/index.vue")
  },
  {
    name: "commerce-contacts",
    path: "contacts",
    component: () => import("/app/pages/commerce/contacts/index.vue")
  },
  {
    name: _91siteId_93QwBV2NWjKbvASP4alXs8ZO7206UCBIiqvy5we0wdzFQMeta?.name,
    path: "sites/:siteId()",
    meta: _91siteId_93QwBV2NWjKbvASP4alXs8ZO7206UCBIiqvy5we0wdzFQMeta || {},
    component: () => import("/app/pages/commerce/sites/[siteId].vue"),
    children: [
  {
    name: "commerce-sites-siteId",
    path: "",
    meta: index2G7XombD1Mej3y6dmk6XJZgSI4ndy8n4HxLHS_45mkp0oMeta || {},
    component: () => import("/app/pages/commerce/sites/[siteId]/index.vue")
  },
  {
    name: "commerce-sites-siteId-contacts",
    path: "contacts",
    component: () => import("/app/pages/commerce/sites/[siteId]/contacts.vue")
  },
  {
    name: "commerce-sites-siteId-relations",
    path: "relations",
    component: () => import("/app/pages/commerce/sites/[siteId]/relations.vue")
  }
]
  },
  {
    name: _91contactId_93HTFrNjsZYFngLiiOW4EyVvkmix_YtXASJiKoP2aee8sMeta?.name,
    path: "contacts/:contactId()",
    meta: _91contactId_93HTFrNjsZYFngLiiOW4EyVvkmix_YtXASJiKoP2aee8sMeta || {},
    component: () => import("/app/pages/commerce/contacts/[contactId].vue"),
    children: [
  {
    name: "commerce-contacts-contactId-edit",
    path: "edit",
    component: () => import("/app/pages/commerce/contacts/[contactId]/edit.vue")
  },
  {
    name: "commerce-contacts-contactId",
    path: "",
    meta: indexaWmJIhhulMPUnLq_7d1lC2RQ3KuQHgqd_6EwnCQdEYkMeta || {},
    component: () => import("/app/pages/commerce/contacts/[contactId]/index.vue")
  },
  {
    name: "commerce-contacts-contactId-sites",
    path: "sites",
    component: () => import("/app/pages/commerce/contacts/[contactId]/sites.vue")
  },
  {
    name: "commerce-contacts-contactId-relations",
    path: "relations",
    component: () => import("/app/pages/commerce/contacts/[contactId]/relations.vue")
  }
]
  },
  {
    name: "commerce-appointments-appointmentId",
    path: "appointments/:appointmentId()",
    meta: _91appointmentId_93rtP5qS6gxZu_45qxA1HkiYu9Jq9gO0GcYDabp7M10hY0IMeta || {},
    component: () => import("/app/pages/commerce/appointments/[appointmentId].vue")
  }
]
  },
  {
    name: "reporting",
    path: "/reporting",
    component: () => import("/app/pages/reporting.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsB9uD7vf6BNbcGL3D9HpazycZMRkcPWG6ea6_45mQfWSE0Meta || {},
    component: () => import("/app/pages/notifications.vue")
  },
  {
    name: "admin-banks",
    path: "/admin/banks",
    component: () => import("/app/pages/admin/banks/index.vue")
  },
  {
    name: "admin-brands",
    path: "/admin/brands",
    component: () => import("/app/pages/admin/brands/index.vue")
  },
  {
    name: "appointment-id",
    path: "/appointment/:id?",
    meta: _91_91id_93_937r1OYvCtCAqniWOmIIhweXT5ikiYq0bAgGWya47L6CUMeta || {},
    component: () => import("/app/pages/appointment/[[id]].vue")
  },
  {
    name: "opportunities",
    path: "/opportunities",
    component: () => import("/app/pages/opportunities/index.vue")
  },
  {
    name: "simulation-cashflow",
    path: "/simulation/cashflow",
    meta: cashflow32_45TMry32DNLaFEsGydw3Ed7s_45B3sxXM7FFNS_IPBmEMeta || {},
    component: () => import("/app/pages/simulation/cashflow.vue")
  },
  {
    name: "admin-banks-bankId",
    path: "/admin/banks/:bankId()",
    component: () => import("/app/pages/admin/banks/[bankId].vue")
  },
  {
    name: "opportunity-cashflow",
    path: "/opportunity/cashflow",
    meta: cashflow4BUgro1qBhWed741eS_4522xsW5LiZXdPo_45V03moPz_4588Meta || {},
    component: () => import("/app/pages/opportunity/cashflow.vue")
  },
  {
    name: "admin-positions",
    path: "/admin/positions",
    component: () => import("/app/pages/admin/positions/index.vue")
  },
  {
    name: "admin-brands-brandId",
    path: "/admin/brands/:brandId()",
    component: () => import("/app/pages/admin/brands/[brandId].vue")
  },
  {
    name: "opportunity-simulation",
    path: "/opportunity/simulation",
    meta: simulationE7_45tnGcQO4eZCCBCM8CtpqqKpvtzT0hUHhG63gYlyCAMeta || {},
    component: () => import("/app/pages/opportunity/simulation.vue")
  },
  {
    name: "admin-orientation",
    path: "/admin/orientation",
    meta: indexH1XdcgOGd92kFLTh5fO_MnInayrepnQlZqIuUN7u6yIMeta || {},
    component: () => import("/app/pages/admin/orientation/index.vue")
  },
  {
    name: "admin-usury_rates",
    path: "/admin/usury_rates",
    component: () => import("/app/pages/admin/usury_rates/index.vue")
  },
  {
    name: "admin-charge_types",
    path: "/admin/charge_types",
    component: () => import("/app/pages/admin/charge_types/index.vue")
  },
  {
    name: "admin-credit_types",
    path: "/admin/credit_types",
    component: () => import("/app/pages/admin/credit_types/index.vue")
  },
  {
    name: "admin-income_types",
    path: "/admin/income_types",
    component: () => import("/app/pages/admin/income_types/index.vue")
  },
  {
    name: "admin-bank_products",
    path: "/admin/bank_products",
    component: () => import("/app/pages/admin/bank_products/index.vue")
  },
  {
    name: "admin-insurance_types",
    path: "/admin/insurance_types",
    component: () => import("/app/pages/admin/insurance_types/index.vue")
  },
  {
    name: "admin-positions-positionId",
    path: "/admin/positions/:positionId()",
    component: () => import("/app/pages/admin/positions/[positionId].vue")
  },
  {
    name: "settings-notifications",
    path: "/settings/notifications",
    meta: index_45Q1mECiYEejd8aBg5M7oZjTpb1_wL5PQwbQgBQBeMyIMeta || {},
    component: () => import("/app/pages/settings/notifications/index.vue")
  },
  {
    name: "admin-contact_positions",
    path: "/admin/contact_positions",
    component: () => import("/app/pages/admin/contact_positions/index.vue")
  },
  {
    name: "admin-transaction_types",
    path: "/admin/transaction_types",
    component: () => import("/app/pages/admin/transaction_types/index.vue")
  },
  {
    name: "admin-excluded_documents",
    path: "/admin/excluded_documents",
    component: () => import("/app/pages/admin/excluded_documents/index.vue")
  },
  {
    name: "admin-contact_event_types",
    path: "/admin/contact_event_types",
    component: () => import("/app/pages/admin/contact_event_types/index.vue")
  },
  {
    name: "admin-usury_rates-usuryRateId",
    path: "/admin/usury_rates/:usuryRateId()",
    component: () => import("/app/pages/admin/usury_rates/[usuryRateId].vue")
  },
  {
    name: "admin-charge_types-ChargeTypeId",
    path: "/admin/charge_types/:ChargeTypeId()",
    component: () => import("/app/pages/admin/charge_types/[ChargeTypeId].vue")
  },
  {
    name: "admin-credit_types-creditTypeId",
    path: "/admin/credit_types/:creditTypeId()",
    component: () => import("/app/pages/admin/credit_types/[creditTypeId].vue")
  },
  {
    name: "admin-income_types-incomeTypeId",
    path: "/admin/income_types/:incomeTypeId()",
    component: () => import("/app/pages/admin/income_types/[incomeTypeId].vue")
  },
  {
    name: "opportunities-opportunityHashId",
    path: "/opportunities/:opportunityHashId()",
    meta: _91opportunityHashId_93pk15iCnpQFE_fkoHwlkEH7Ufh4tZuczWpy1M0nxbD1QMeta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId].vue"),
    children: [
  {
    name: "opportunities-opportunityHashId-edit",
    path: "edit",
    meta: editFfAyXCPULifBTEQJPy4QmcyUh9rWPcndCHfGBdA8H_QMeta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/edit.vue")
  },
  {
    name: "opportunities-opportunityHashId-history",
    path: "history",
    component: () => import("/app/pages/opportunities/[opportunityHashId]/history.vue")
  },
  {
    name: "opportunities-opportunityHashId-preview",
    path: "preview",
    component: () => import("/app/pages/opportunities/[opportunityHashId]/preview.vue")
  },
  {
    name: "opportunities-opportunityHashId-analysis",
    path: "analysis",
    component: () => import("/app/pages/opportunities/[opportunityHashId]/analysis.vue"),
    children: [
  {
    name: "opportunities-opportunityHashId-analysis-balance",
    path: "balance",
    meta: balanceSm2qYMR7Gpq4h6YGnw25f__2JByTiV0NT_pbsoVT8lUMeta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/analysis/balance.vue")
  },
  {
    name: "opportunities-opportunityHashId-analysis-comments",
    path: "comments",
    meta: commentsqv72mqDlih10PK_7BHfsi_10pm_2jpZcaWYIU09LbSQMeta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/analysis/comments.vue")
  },
  {
    name: "opportunities-opportunityHashId-analysis-recap-ia",
    path: "recap-ia",
    meta: recap_45iavKFYFREV76BjcxnYbv0TNJpYKSBsEVdZTYNgqkD5fNsMeta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/analysis/recap-ia.vue")
  },
  {
    name: "opportunities-opportunityHashId-analysis-synthesis",
    path: "synthesis",
    component: () => import("/app/pages/opportunities/[opportunityHashId]/analysis/synthesis.vue")
  },
  {
    name: "opportunities-opportunityHashId-analysis-operations",
    path: "operations",
    meta: operationsj6Z0GxiWJsTmfcCathLhyaOT6IuXE3_BHlcBLPzShjcMeta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/analysis/operations.vue")
  },
  {
    name: "opportunities-opportunityHashId-analysis-bank-accounts-bankAccountId",
    path: "bank-accounts/:bankAccountId()",
    meta: _91bankAccountId_93Xbm01ENaXmbBOJ_45xx9jATweratbJhQMabQWnPsNb_7gMeta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/analysis/bank-accounts/[bankAccountId].vue")
  },
  {
    name: "opportunities-opportunityHashId-analysis-bank-account-statements-bankAccountStatementId",
    path: "bank-account-statements/:bankAccountStatementId()",
    meta: _91bankAccountStatementId_93r1ZymAWvUUYHwRmxIZ0fNLearDE1Q6Sv0Pv5qWK_45zz4Meta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/analysis/bank-account-statements/[bankAccountStatementId].vue")
  }
]
  },
  {
    name: "opportunities-opportunityHashId-messages",
    path: "messages",
    component: () => import("/app/pages/opportunities/[opportunityHashId]/messages.vue"),
    children: [
  {
    name: "opportunities-opportunityHashId-messages-deleted",
    path: "deleted",
    meta: deletedA_45ZFJowZJ5OoF2890jvlyP0Zw1Olg1KsTZFtTOJK10AMeta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/messages/deleted.vue")
  },
  {
    name: "opportunities-opportunityHashId-messages-received",
    path: "received",
    meta: receivedgCU476r6Hm92WWfiV0B8Oll_Y_45XXdmTgZWlHIvVcRLAMeta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/messages/received.vue")
  },
  {
    name: "opportunities-opportunityHashId-messages-generated",
    path: "generated",
    meta: generatedK42VuRKD1m9I_XF2Cub9zC90mEnUZbiQnBPqBu2JwH8Meta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/messages/generated.vue")
  }
]
  },
  {
    name: "opportunities-opportunityHashId-documents",
    path: "documents",
    component: () => import("/app/pages/opportunities/[opportunityHashId]/documents.vue"),
    children: [
  {
    name: "opportunities-opportunityHashId-documents-all",
    path: "all",
    meta: all11Sj6Vuoe6gBG0UbKUSMNIJOYYXdokJNGm9y4j6b1X8Meta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/documents/all.vue")
  },
  {
    name: "opportunities-opportunityHashId-documents-deleted",
    path: "deleted",
    meta: deleted6fbDg2aD4B_45qNeMotlRluZFDofUhfv9JCW5bmQ8Y450Meta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/documents/deleted.vue")
  }
]
  },
  {
    name: "opportunities-opportunityHashId-simulation",
    path: "simulation",
    component: () => import("/app/pages/opportunities/[opportunityHashId]/simulation.vue"),
    children: [
  {
    name: "opportunities-opportunityHashId-simulation-auto",
    path: "auto",
    meta: autoQi3OGr0MMa6I5Yj_45HtuKKImVVaBDiyPX4K21TyL_4wsMeta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/simulation/auto.vue")
  },
  {
    name: "opportunities-opportunityHashId-simulation-blink-simulationLegacyId",
    path: "blink/:simulationLegacyId()",
    meta: _91simulationLegacyId_93xLjHEq8xxGe7KKxBqg9ieWL61tSy01By1Ryc7gYSR54Meta || {},
    component: () => import("/app/pages/opportunities/[opportunityHashId]/simulation/blink/[simulationLegacyId].vue")
  }
]
  }
]
  },
  {
    name: "admin-bank_products-bankProductId",
    path: "/admin/bank_products/:bankProductId()",
    component: () => import("/app/pages/admin/bank_products/[bankProductId].vue")
  },
  {
    name: "admin-bank_product_commissions",
    path: "/admin/bank_product_commissions",
    component: () => import("/app/pages/admin/bank_product_commissions/index.vue")
  },
  {
    name: "admin-insurance_types-insuranceTypeId",
    path: "/admin/insurance_types/:insuranceTypeId()",
    component: () => import("/app/pages/admin/insurance_types/[insuranceTypeId].vue")
  },
  {
    name: "admin-contact_positions-contactPositionId",
    path: "/admin/contact_positions/:contactPositionId()",
    component: () => import("/app/pages/admin/contact_positions/[contactPositionId].vue")
  },
  {
    name: "admin-transaction_types-TransactionTypeId",
    path: "/admin/transaction_types/:TransactionTypeId()",
    component: () => import("/app/pages/admin/transaction_types/[TransactionTypeId].vue")
  },
  {
    name: "admin-excluded_documents-excludedDocumentId",
    path: "/admin/excluded_documents/:excludedDocumentId()",
    component: () => import("/app/pages/admin/excluded_documents/[excludedDocumentId].vue")
  },
  {
    name: "admin-contact_event_types-ContactEventTypeId",
    path: "/admin/contact_event_types/:ContactEventTypeId()",
    component: () => import("/app/pages/admin/contact_event_types/[ContactEventTypeId].vue")
  },
  {
    name: "admin-bank_product_commissions-bankProductCommissionId",
    path: "/admin/bank_product_commissions/:bankProductCommissionId()",
    component: () => import("/app/pages/admin/bank_product_commissions/[bankProductCommissionId].vue")
  }
]